import React from "react";
import "./WaitingApproval.css";

interface WaitingApprovalProps {
  username: string;
}

const WaitingApproval: React.FC<WaitingApprovalProps> = ({ username }) => {
  return (
    <div className="waiting-approval">
      <div className="container waiting-approval-card">
        <div className="waiting-approval-icon">⏳</div>
        <h1>Conta em análise</h1>
        <p>
          Olá, <strong>{username}</strong>! Sua conta ainda precisa ser aprovada
          por nossa equipe.
        </p>
        <div className="waiting-approval-message">
          <p>
            Prezamos pela segurança e qualidade da nossa comunidade. Em poucos
            dias você terá acesso total!
          </p>
        </div>
      </div>
    </div>
  );
};

export default WaitingApproval;
